import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

export const server = new BehaviorSubject<string>(environment.apiUrl);

export const SMI_MAKE_PAYMENT_IOS = "https://ga.smartchildsupport.com/Mobile?platform=ios";
export const SMI_MAKE_PAYMENT_ANDROID = "https://ga.smartchildsupport.com/Mobile?platform=android";
export const SMI_MAKE_PAYMENT_PWA = "https://ga.smartchildsupport.com/Mobile?platform=dcssmobile";
export const HELPME_URL = 'https://online.dds.ga.gov/onlineservices/';

export const FATHERHOOD_URL =
  'https://childsupport.georgia.gov/programs-services/fatherhood-program';
export const COURT_PROGRAM =
  'https://childsupport.georgia.gov/programs-services/parental-accountability-court-program';
export const ACCESS_VISITATION =
  'https://childsupport.georgia.gov/programs-services/access-visitation';
export const USER_AGREEMENT_URL = 'http://dcss.dhs.georgia.gov';
export const OFFICE_FINDER_DETAILS_SERVICE = '/api/office/public/details';
export const ANNOUNCEMENT_SERVICE = '/api/public/getAnnouncements';
export const GET_ANNOUNCEMENT_MOB_PARAMS_SERVICE = '/api/commonapi/public/getlandingpagedetails';

export const CASE_ACTIVITY_SERVICE = '/api/caseActivity';
export const APPLICATION_STATUS = '/api/public/appstatus';

export const USER_DEMOGRAPHIC_DETAILS_NCP = '/api/demographics/ncp/info';
export const USER_DEMOGRAPHIC_DETAILS_CP = '/api/demographics/cp/info';
export const PAYMENT_HISTORY_SERVICE_NCP = '/api/payment/info/ncp';
export const PAYMENT_HISTORY_DETAILS_NCP = '/api/payment/details/ncp';
export const PAYMENT_HISTORY_DETAILS_CP = '/api/payment/details/cp';
export const CASE_INFORMATION_DETAILS = '/api/case/';
export const UPDATE_USER_DEMOGRAPHIC_DETAILS_NCP =
  '/api/demographics/ncp/update';
export const UPDATE_USER_DEMOGRAPHIC_DETAILS_CP = '/api/demographics/cp/update';
//DEV SERVER .75
export const LOGIN_SERVICE = '/api/public/login/';
export const LATEST_APP_VERSION_SERVICE =
  '/api/version/public/getLatestAppVersion';
export const FAQS_SERVICE = '/api/faqs/public/';
export const DOCUPLOAD_GETSCANCONFIG = '/api/documentscan/getScanConfig';
export const DOCUPLOAD_CLEANTEMPDOCS = '/api/documentscan/cleanTempDocs';
export const DOCUPLOAD_CLEANIMAGES = '/api/documentscan/cleanImages';
export const DOCUPLOAD_FETCHDOCBYLOCALNAME =
  '/api/documentscan/fetchDocByLocalName';
export const DOCUPLOAD_ADDDOCTOTEMPDOC =
  '/api/documentscan/addDocToTempDocument';
export const DOCUPLOAD_ADDDOCTOTEMPDOC_DD =
  '/api/documentscan/addDocToTempDocumentDD';
export const DOCUPLOAD_UPLOADSCANDOC = '/api/documentscan/uploadScanDocument';
export const DOCUPLOAD_HISTORY = '/api/documenthistory/docUploadHist';
export const DOCUPLOAD_FETCHDOCBYID = '/api/documenthistory/fetchDocByDid';
export const DOCUPLOAD_DOCVIEWSTATUS = '/api/documenthistory/docHistViewStat';
export const DOCUPLOAD_GENERATEPDF = '/api/documentscan/generatePDF';
export const DOCUPLOAD_DELETEDOCBYID =
  '/api/documentscan/deleteTempDocumentById';
export const SUPPORT_ORDER = '/api/supportOrder';
export const DOCUPLOAD_SCANIMAGECORDS = '/api/documentscan/scanImageCords';
export const DOCUPLOAD_INIT_UPLOAD_IMAGE = '/api/documentscan/initdocupload';
export const LOGOUT = '/api/logout';

export const DOCUPLOAD_UPLOADIMAGE = '/api/documentscan/uploadImage';
export const DOCUPLOAD_CROPIMAGE = '/api/documentscan/cropImage';
export const SELF_RESET_PWD = '/api/public/selfResetPwd';
export const SEND_CONTACT_EMAIL_SERVICE =
  '/api/customerservice/public/sendContactEmailService';
export const SEND_CONTACT_EMAIL_SERVICE_AUTH =
  '/api/customerservice/sendContactEmailServiceAuth';
export const SEND_CONTACT_EMAIL_SERVICE_TECH_SUPPORT =
  '/api/customerservice/public/techSendEmail';
  export const SEND_CONTACT_EMAIL_SERVICE_AUTH_TECH_SUPPORT =
  '/api/customerservice/techSendEmailAuth';
export const NOTIFICATIONS_FETCHPUSH_NOTIFICATIONS =
  '/api/pushnotification/fetchPushNotifications';
export const DIRECT_DEPOSIT_SUBMIT_SERVICE = '/api/directdeposit/submit';
export const DIRECT_DEPOSIT_FETCH_SERVICE = '/api/directdeposit/fetch';
export const DIRECT_DEPOSIT_DOWNLOAD_FORM = '/api/documentscan/getddform';
export const FETCH_UPCOMING_PAST_APPOINTMENTS =
  '/api/alertsservice/caseAppointments';
export const PUSH_NOTIFICATIONS_IS_SUBSCRIBED =
  '/api/pushnotification/isSubscribed';
export const PUSH_NOTIFICATIONS_SUBSCRIBE =
  '/api/pushnotification/registerUserDevice';
export const ANDROID_APP_DOWNLOAD_URL = '/api/presigned/public/environmenturl';
export const UPDATE_PASSWORD = '/api/updatePassword';
export const USER_AGREEMENT_AGREE = '/api/setUserAgreementStatus';
export const LICENSE_STATUS = '/api/license/licenseStatus';
export const LOGIN_REFRESH_TOKEN = '/api/token/refresh';
export const GET_UI_KEYS = '/api/commonapi/getuikeys';
export const FETCH_APPOINTMENT_EMAIL_SERVICE =
  '/api/appointments/fetchAppointmentEmailService';
export const CHAT_URL = '/api/customerservice/public/fetchChatPortalUrl';
export const CHAT_STATUS = '/api/customerservice/public/fetchChatStatus';
export const ALERT_MESSAGES_NOTIFICATIONS = '/api/alerts/fetchAlertMessages';
export const DISMISS_ALERT_NOTIFICATIONS = '/api/alerts/dismissAlertMessages';

export const ADDRESS_DETAILS = '/api/demographics/info/';

export const PAYMENT_OPTIONS = '/api/documentsign/getPaymantOptions/';

export const DEFERRAL_MRA_REVIEW_FORM = '/api/documentsign/signlicense';

export const SUPPORT_ORDER_DETAILS = '/api/supportOrder/details';
export const OFFICE_FINDER_LIST_SERVICE = '/api/office/public/list';
export const REGISTRATION_SERVICE = '/api/public/member';
export const APPOINTMENT_REQ_SERVICE =
  '/api/appointments/appointmentRequestService';
export const FETCH_CLOSE_MY_CASE = '/api/fetchCloseMyCase';
export const SUBMIT_CLOSE_MY_CASE = '/api/submitCloseMyCase';
export const INIT_DOC_SIGN = '/api/documentsign/initdocsign';
export const DEFERRAL_MRA_SUBMIT_FORM = '/api/documentsign/uploadDocument';
export const SUBMIT_CASE_ALERT_SERVICE =
  '/api/alertsservice/submitCaseAlertService';
export const FETCH_CASE_ALERT_SERVICE =
  '/api/alertsservice/fetchCaseAlertService';

export const BEFORE_LOGIN_PAYMENT_URL = '/api/payment/public/getPaymentUrl';
export const AFTER_LOGIN_PAYMENT_URL = '/api/payment/getPaymentUrl';

export const BEFORE_DRIVING_LICENSE_RELEASE_PROCESS =
  '/api/commonapi/public/dlreleaseprocess';

export const AFTER_DRIVING_LICENSE_RELEASE_PROCESS =
  '/api/commonapi/dlreleaseprocess';

export const BEFORE_FATHERHOOD = '/api/commonapi/public/fatherhood';

export const AFTER_FATHERHOOD = '/api/commonapi/fatherhood';

export const BEFORE_PARENTAL_ACCOUNTABILITY_COURT =
  '/api/commonapi/public/parentalcourt';

export const AFTER_PARENTAL_ACCOUNTABILITY_COURT =
  '/api/commonapi/parentalcourt';

export const BEFORE_ACCESS_VISITATION_COURT =
  '/api/commonapi/public/accessvisitationcourt';

export const AFTER_ACCESS_VISITATION_COURT =
  '/api/commonapi/accessvisitationcourt';

export const BEFORE_MONEYGRAM = '/api/commonapi/public/moneygram';

export const AFTER_MONEYGRAM = '/api/commonapi/moneygram';


export const BEFORE_PAYMENT = '/api/commonapi/public/dlpurgepayment';

export const AFTER_PAYMENT =  '/api/commonapi/dlpurgepayment';



export const BEFORE_APPLY_SERVICES = '/api/public/apply/';
export const TECH_SUPPORT_EN = "/api/techsupport/public/en";
export const TECH_SUPPORT_ES = "/api/techsupport/public/es";

export const NCP_BLOCKED_USER_CHECK = '/api/documentscan/ncpblockedusercheck';
